import { ReactNode, useMemo } from "react";
import useShortcut, { ShortCuts } from "../../hooks/UseShortcutsHook";
import { TimelineClipboardContext } from "./CopyPasteContext";
import { useTimelineCopyPaste } from "./useTimelineCopyPaste";

// Provides the timeline clipboard handlers to row menus in subtrees where no
// component instantiates useTimelineCopyPaste itself (the 3D editor body),
// and owns the keyboard bindings for that subtree. Binding here (instead of
// in StoryboardTimeline3D) keeps the shortcuts alive while the quiz feedback
// panel replaces the storyboard with its collapsed rail.
export default function TimelineClipboardProvider(props: {
  children: ReactNode;
}) {
  const {
    handleCopy,
    handleCut,
    handlePaste,
    handlePasteIntoSlot,
    handleDuplicate,
  } = useTimelineCopyPaste();

  useShortcut(ShortCuts.Copy, handleCopy);
  useShortcut(ShortCuts.Cut, handleCut);
  useShortcut(ShortCuts.Paste, handlePaste);
  useShortcut(ShortCuts.Duplicate, handleDuplicate);

  const value = useMemo(
    () => ({ handleCopy, handleCut, handlePaste, handlePasteIntoSlot }),
    [handleCopy, handleCut, handlePaste, handlePasteIntoSlot]
  );

  return (
    <TimelineClipboardContext.Provider value={value}>
      {props.children}
    </TimelineClipboardContext.Provider>
  );
}
